import React from 'react';
import { Drawer, FormUser } from '../../components';
import { useStyles } from '../../services/material-ui';
import RowHeaderHelp from '../../components/RowHeaderHelp';
import LabTabs from '../../components/molecules/configuration/users/screens';

const CreateUser: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <RowHeaderHelp name="Novo Usuário" />
        <FormUser />
      </main>
    </div>
  );
};

export default CreateUser;
